/*
 * @providesModule BracketStore
 *
 */

import MinFlux from 'min-flux';
import RESTStore from 'RESTStore';
import SKZBracket from 'SKZBracket';

import {NativeModules} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

/*TODO:
It currently uses `MinFlux`, and it seems `MinFlux` does not store the
data after it is accessed, it is thrown away, or the scaping could be weird
so every call after the
first call returned null. I created a `this._bracket` varaible inside of
`BracketView`, where it will update the bracket if the new data ever comes in.
This will have to be reconstructed at one point to just use a BracketController
class to store and manipulate this data instead of this `BracketStore` class.
*/

const BracketStore = new MinFlux.Store({
  getData(): SKZBracket {
    return new SKZBracket(this._data);
  },

  fetchBracket(bracketId, completion, useCache = false) {
    const getResponse = useCache
      ? RESTStore.getAnyResponse.bind(RESTStore)
      : RESTStore.getServerResponse.bind(RESTStore);

    getResponse(
      'brackets/' + bracketId,
      null,
      SKZAPIManager.OnError.promptRetry,
      (response, error) => {
        if (response) {
          completion(new SKZBracket(response), null);
        } else {
          completion(null, error);
        }
      }
    );
  },

  actionTypeHandlers: {
    FETCH_BRACKET(action) {
      this.fetchBracket(
        action.payload.bracketId,
        (response) => {
          this._data = response;
          this.emitChange();
        },
        action.payload.useCache
      );
    },
  },
});

export {BracketStore as default};
